var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconUnknownComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? false : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-Unknown ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895432 0.895431 0 2 0H34C35.1046 0 36 0.895431 36 2V34C36 35.1046 35.1046 36 34 36H2C0.895432 36 0 35.1046 0 34V2Z",
    fill: useCurrentColor ? 'currentColor' : '#E6E6E6'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6168 14.1205C14.6168 12.2362 16.1443 10.7087 18.0285 10.7087C19.89 10.7087 21.3836 12.2133 21.3836 14.1205C21.3836 15.3869 20.7941 16.3223 19.7672 16.9173C18.3219 17.7546 16.5146 19.3384 16.5146 21.6908V22.8456H19.5425V21.6908C19.5425 21.0135 20.1089 20.2187 21.2851 19.5372C23.1993 18.4282 24.4115 16.5206 24.4115 14.1205C24.4115 10.5869 21.6079 7.6808 18.0285 7.6808C14.472 7.6808 11.5889 10.5639 11.5889 14.1205H14.6168ZM17.9982 28.3192C19.0852 28.3192 19.9664 27.438 19.9664 26.351C19.9664 25.2641 19.0852 24.3829 17.9982 24.3829C16.9112 24.3829 16.0301 25.2641 16.0301 26.351C16.0301 27.438 16.9112 28.3192 17.9982 28.3192Z",
    fill: useCurrentColor ? 'currentColor' : '#BFBFBF'
  }));
}
var IconUnknown = /*#__PURE__*/React.forwardRef(IconUnknownComponent);
export default IconUnknown;